import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { GetNPPESDetailsData } from "../services/PhysicianDetails";
import { ApplicationState } from "../store/ApplicationState";
import { ReferralIntakePhysicianDetailsDispatchTypes } from "../models/DispatchTypes/PhysicianDetails";
import { GetNPPESDataActionDispatchTypes } from "../constants/PhysicianDetails";
import { configUrl } from "../constants/Config";

export const getNPPEsDetailsData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralIntakePhysicianDetailsDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_INVOKE,
    });

    const response = await GetNPPESDetailsData(
      configUrl,
      payload
    );

    dispatch({
      response,
      type: GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_SUCCESS,
    });
  };
};
